var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenSpaceWallFollowNavigatorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25.987mm",
    height: "26.013mm",
    viewBox: "0 0 25.987 26.013",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79.11,0.26491)",
    strokeLinejoin: "round",
    id: "g8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 26.987,0.54985 v 24.384 l 17.904,-0.03036 v -6.1923 l 6.4958,-0.01102 -0.01613,-18.192 z",
    fill: "#f9f9f9",
    stroke: "#707070",
    strokeWidth: 1.5875,
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 0.52917,0.57052 v 24.384 l 17.904,-0.03036 v -6.1923 l 6.4958,-0.01102 -0.01613,-18.192 z",
    fill: "#f9f9f9",
    stroke: "#707070",
    strokeWidth: 1.5875,
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2.4721,2.4869 2.9944,20.689 8.8101,-20.696 8.7706,7.2442 -10.013,7.0167",
    fill: "none",
    stroke: "#6fcf89",
    strokeLinecap: "round",
    strokeOpacity: 0.75,
    strokeWidth: 1.5596,
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.974,2.5952 20.452,-0.034608 0.01355,14.202 -6.5065,0.01608 0.01322,6.1973 -13.971,0.02542 v -15.142",
    fill: "none",
    stroke: "#6fcf89",
    strokeLinecap: "round",
    strokeOpacity: 0.75,
    strokeWidth: 1.5401,
    id: "path4"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5875,
    id: "g7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 53.446,0.57052 v 24.384 L 71.35,24.92416 v -6.1923 l 6.4958,-0.01102 -0.01613,-18.192 z",
    fill: "#f9f9f9",
    stroke: "#707070",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.256,2.2557 8.0361,18.727 3.9994,-18.734 8.5891,7.3622 0.01479,7.1923 -6.3956,0.01659 0.01361,6.1197 -14.045,0.02622 v -15.342",
    fill: "none",
    stroke: "#6fcf89",
    strokeLinecap: "round",
    strokeOpacity: 0.75,
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 56.325032,-27.964537 v 24.3840001 l 11.706,0.03064 V -15.543632 l 12.69378,-0.0513 -0.0161,-12.411291 z",
    fill: "#ffffff",
    stroke: "#707070",
    id: "path7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g9",
    transform: "translate(-58.699344,2.4137737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 138.61208,-1.839038 v 24.384 L 148.61,22.54509 V 10.581869 l 14.40193,-0.0513 -0.0161,-12.411291 z",
    fill: "#ffffff",
    stroke: "#707070",
    id: "path7-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 140.49108,0.192942 20.616,-0.04355 -0.0228,2.5104 h -20.624 v 2.6684 h 20.625 v 2.6113 H 140.46 v 2.642598 h 6.25 v 2.753 h -6.25 v 2.75 h 6.25 v 2.85 h -6.25 v 1.820151",
    fill: "none",
    stroke: "#6fcf89",
    strokeLinecap: "round",
    strokeOpacity: 0.75,
    strokeWidth: 1.5712,
    id: "path8-2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 58.204032,-25.932557 20.616,-0.04355 -0.0228,2.5104 h -20.624 v 2.6684 h 20.625 v 2.6113 h -20.667 v 12.6860401 h 2.6898 l -1e-5,-10.0750001 2.71001,1.65e-4 v 10.0748351 h 2.7 v -7.3684611",
    fill: "none",
    stroke: "#6fcf89",
    strokeLinecap: "round",
    strokeOpacity: 0.75,
    strokeWidth: 1.5712,
    id: "path8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSpaceWallFollowNavigatorIcon);
export default __webpack_public_path__ + "static/media/OpenSpaceWallFollowNavigatorIcon.fd647366cc54723f5da7ea126ac9d0cb.svg";
export { ForwardRef as ReactComponent };